import { useEffect } from 'react';

export const useWalletReconnection = (onReconnect, dependencies = []) => {
  useEffect(() => {
    const handleWalletReconnected = () => {
      console.log("Wallet reconnected, executing callback...");
      if (typeof onReconnect === 'function') {
        onReconnect();
      }
    };

    window.addEventListener('WALLET_RECONNECTED', handleWalletReconnected);
    
    return () => {
      window.removeEventListener('WALLET_RECONNECTED', handleWalletReconnected);
    };
  }, dependencies);
};

export const useWalletReconnectionWithLoader = (
  setLoader, 
  setText, 
  web3AccountCheck, 
  setWeb3, 
  setAccount, 
  refreshData, 
  web3Contract
) => {
  useWalletReconnection(() => {
    console.log("Wallet reconnected, refreshing data...");
    setLoader(false); 
    setText("");
    web3AccountCheck(setWeb3, setAccount);
    if (web3Contract && refreshData) {
      refreshData();
    }
  }, [web3Contract]);
};
